<template>
  <div id="header">
    <ul>
      <li class="headleft">
        <img src="@/assets/logo.png" alt="">
        <span>量云</span>
      </li>
      <li class="headright">
        <div class="name">消耗管理平台</div>
        <div class="usermsg">
          <span class="time">2023年10月12日</span>
          <div class="imgbox commomImg">
            <img src="@/assets/mi_notification.png" alt="">
          </div>
          <div class="user">
            <img :src="userMsg.avatar" alt="" class="avatar">
            <span>{{userMsg.name}}</span>
            <img src="@/assets/akar-icons_chevron-down.png" alt="" class="go">
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name:"zxHeader",
  data(){
    return {
      userMsg:{
        avatar:require("@/assets/user.png"),
        name:"管理员"
      }
    }
  }
}
</script>

<style lang="less">
#header{
  width: 100%;
  background-color: #fff;
  border-radius: 24px;
  padding: 20px 50px 20px 24px;
  box-shadow: 0px 20px 60px  rgba(0, 0, 0, 0.05);
  margin-bottom: 70px;
  ul{
    display: flex;
    .headleft{
      display: flex;
      align-items: center;
      font-size: 28px;
      font-weight: 400;
      letter-spacing: 0.28px;
      color: rgba(0, 30, 192, 1);
      padding-right: 66px;
      border-right: 1px solid rgba(211, 211, 211, 1);
      margin-right: 22px;
      img{
        margin-right: 6px;
        width: 40px;
      }
    }
    .headright{
      flex: 1 0 10%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .name{
        font-size: 28px;
        font-weight: 400;
        color: rgba(0, 30, 192, 1);

      }
      .usermsg{
        display: flex;
        align-items: center;
        .avatar{
          width:52px;
          margin-right: 12px;
        }
        .time{
          font-size: 16px;
          font-weight: 400;
          color: rgba(163, 163, 163, 1);
          display: inline-block;
          margin-right: 12px;
        }
        .user{
          margin-left: 20px;
          display: flex;
          align-items: center;
        }
        .go{
          width: 20px;
          margin-left: 18px;
        }
      }
    }
  }
}
</style>